import React from "react";
import { Spin } from '@kdcloudjs/kdesign'
import styles from "./bigScreen.less";

function LoaddingSpin (props) {
    const { model, getLangMsg } = props
    return <div className={styles.loaddingSpin}>
        {/* <div className={styles.loaddingImg}><Spin style={{transform: 'scale(1.5)', '--kd-c-spin-page-dot-item-sizing-square': '14px'}}/></div> */}
        {/* <div className={styles.loaddingImg}><Spin style={{transform: 'scale(1.5)'}}/></div> */}
        <div className={styles.loaddingImg}><Spin/></div>
        <span>{getLangMsg('loaddingSpin.key0001')}</span>
        <span>{getLangMsg('loaddingSpin.key0002')}</span>
    </div>
}

export default LoaddingSpin;